import React, { type ChangeEvent, useCallback, useState } from 'react';
import { Form } from 'react-final-form';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

type Props = {
  title: string;
  description: string;
  open: boolean;
  onSubmit: (value: string) => void;
  initialValue: string;
  handleClose: () => void;
  confirmButtonLabel: string;
  onDelete?: () => void;
};
export default function ScenarioDialog({
  confirmButtonLabel,
  title,
  description,
  handleClose,
  onSubmit,
  initialValue,
  onDelete,
}: Props) {
  const [name, setName] = useState(initialValue);

  const handleSubmit = () => {
    if (name.trim().length === 0) {
      return;
    }
    onSubmit(name);
    handleClose();
  };
  const onChange = useCallback(
    (ev: ChangeEvent<HTMLInputElement>) => {
      setName(ev.target.value);
    },
    [setName]
  );

  const renderDeleteButton = () => {
    if (!onDelete) {
      return <Box />;
    }
    return (
      <Button
        color="error"
        onClick={() => {
          onDelete();
          handleClose();
        }}
      >
        Remove
      </Button>
    );
  };

  return (
    <Dialog open onClose={handleClose} maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <Form onSubmit={handleSubmit}>
        {({ handleSubmit }) => (
          <Box
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleSubmit();
            }}
          >
            <DialogContent>
              <Typography color="text.secondary" paragraph>
                {description}
              </Typography>
              <TextField
                fullWidth
                autoFocus
                label="Scenario name"
                margin="dense"
                helperText="Example: 'Free shipping'."
                onChange={onChange}
                value={name}
              />
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between' }}>
              {renderDeleteButton()}
              <Stack direction="row" spacing={1}>
                <Button color="secondary" onClick={handleClose}>
                  Cancel
                </Button>
                <Button type="submit" variant="outlined" disabled={name.trim().length === 0}>
                  {confirmButtonLabel}
                </Button>
              </Stack>
            </DialogActions>
          </Box>
        )}
      </Form>
    </Dialog>
  );
}
